/*
 * Black Friday - Fallender Effekt (Ultimate Sale / Hype)
*/
document.addEventListener('DOMContentLoaded', function() {

  // --- Konfiguration (Ultimate Sale) ---
  // Farben: Gold (Edel), Weiß (Kontrast), Rot (Signal/Rabatt)
  // Wir lassen Schwarz weg, damit man es auf dem dunklen Banner gut sieht!
  const a_farben = ['#FFD700', '#FFFFFF', '#FF0033']; 

  // Symbole: Eindeutige Shopping-Signale
  const a_symbole = ['%', '🏷️', '🛍️', '🔥', '⚡']; 

  // Intervall: 250ms = Etwas schneller, damit mehr "los" ist
  const a_intervall = 250; 

  // Dauer: 6-8 Sekunden (Variable Fallgeschwindigkeit für mehr Dynamik)
  // --- Ende Konfiguration ---
  

  function erstellePartikel() {
    const partikel = document.createElement('span');
    
    const farbe = a_farben[Math.floor(Math.random() * a_farben.length)];
    const symbol = a_symbole[Math.floor(Math.random() * a_symbole.length)];
    
    // Größe variiert stärker (15px bis 30px) für mehr Tiefe
    const groesse = Math.random() * 15 + 15; 
    
    const startPosition = Math.random() * 100;
    const rotation = Math.random() * 360;
    const endRotation = rotation + (Math.random() * 720 - 360);

    // Zufällige Fall-Dauer für jedes Teilchen (zwischen 6s und 9s)
    const individuelleDauer = Math.random() * 3000 + 6000; 

    // --- Styling ---
    partikel.innerHTML = symbol;
    partikel.style.position = 'fixed';
    partikel.style.top = '-50px';
    partikel.style.left = startPosition + 'vw';
    partikel.style.fontSize = groesse + 'px';
    partikel.style.color = farbe;
    
    // Ein 'Glow' statt Schatten, damit es auf Schwarz knallt
    partikel.style.textShadow = `0 0 8px ${farbe}`; 
    
    partikel.style.opacity = '1';
    partikel.style.zIndex = '99999';
    partikel.style.pointerEvents = 'none';
    // Nutze die individuelle Dauer
    partikel.style.transition = `transform ${individuelleDauer / 1000}s linear, opacity ${individuelleDauer / 1000}s ease-out`;
    partikel.style.transform = `rotate(${rotation}deg)`;
    // --- Ende Styling ---

    document.body.appendChild(partikel);

    // Leichte seitliche Drift für Chaos-Faktor
    const drift = Math.random() * 100 - 50; // -50px bis +50px

    setTimeout(() => {
      partikel.style.transform = `translateY(110vh) translateX(${drift}px) rotate(${endRotation}deg)`;
      partikel.style.opacity = '0';
    }, 10);

    setTimeout(() => {
      partikel.remove();
    }, individuelleDauer + 500);
  }

  setInterval(erstellePartikel, a_intervall);
});